module.exports = __webpack_public_path__ + "media/images/icons/price-green-740ae9e9bd56680b521f31c829580a5e.svg";